import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Paths } from './components/Paths';
import { Included } from './components/Included';
import { Pricing } from './components/Pricing';
import { ForWhom } from './components/ForWhom';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
}
export function App({
  showUrgency = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-cream text-ink" data-id="element-0" data-mp="23vkzcrxgytqi">
      {showUrgency && <UrgencyBar data-id="element-1" data-mp="23t8fuac2cbbc" />}
      <main data-id="element-2" data-mp="3ijxokogyjwiu">
        <Hero data-id="element-3" data-mp="3ikh8ubu2yx01" />
        <StatsBar data-id="element-4" data-mp="3ikqwvtvkeu33" />
        <Problem data-id="element-5" data-mp="3ij61k21ff746" />
        <Solution data-id="element-6" data-mp="3ijpef4c7z5bc" />
        <Volumes data-id="element-7" data-mp="3mlja0y7k5j4n" />
        <Bonuses data-id="element-8" data-mp="3ml14tc2x3ukl" />
        <Paths data-id="element-9" data-mp="3mkhlps1j704z" />
        <Included data-id="element-10" data-mp="3mk83iqmq9x9u" />
        <Pricing showUrgency={showUrgency} data-id="element-11" data-mp="3mjpyp5m02aqb" />
        <ForWhom data-id="element-12" data-mp="3rbrbcsn2y3gv" />
        <Guarantee data-id="element-13" data-mp="3rdaselgk8ijp" />
        <Faq data-id="element-14" data-mp="3rcsxbs5mwadd" />
        <FinalCta showUrgency={showUrgency} data-id="element-15" data-mp="3recedkz46pg7" />
      </main>
      <Footer data-id="element-16" data-mp="4wv3njt0sf7" />
    </div>;
}